import { consumer, core } from '@tock/coretypes';
import { uniq } from 'es-toolkit/compat';

export type OfferingSingleSlugConsumer = 'experience' | 'event' | 'special-table' | 'detail';
const varietyToSingleSlugConsumer: {
  [K in core.TicketType.Variety | consumer.Offering.Type]: OfferingSingleSlugConsumer;
} = {
  DEPOSIT: 'experience',
  FULL: 'experience',
  PRIX_FIXE: 'experience',
  RESERVATION: 'experience',
  DEPRECATED_EVENT: 'event',
  GA_EVENT: 'event',
  SEATED_EVENT: 'event',
  DEPRECATED_SPECIAL_TABLE: 'special-table',
  ORDER_DELIVERY: 'experience',
  ORDER_PICKUP: 'experience',
  TABLESIDE: 'experience',
};
export const ALL_OFFERING_SINGLE_SLUGS_CONSUMER: OfferingSingleSlugConsumer[] = [
  ...uniq(Object.values(varietyToSingleSlugConsumer)),
  'detail',
];

/**
 * Returns the slug for a single one of the offering type
 */
export function offeringSingleSlugConsumer(
  variety: core.TicketType.Variety | consumer.Offering.Type
) {
  return varietyToSingleSlugConsumer[variety];
}
